export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__content">
          <p className="footer__text">
            &copy; 2025 Review Trường. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
